import React from 'react'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import config from '../config'
import { LoginPage } from '../pages/LoginPage'
import WelcomePage from '../pages/WelcomePage'
import routes from '../routes'
import { SIZES } from '../styles/theme'

const Page = styled.div`
  background: url(${config.assets.entrance.landscape}) no-repeat top;
  background-size: 100% 100%;
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;

  #mobile-show {
    display: none;
  }
  #mobile-hide {
    display: block;
    position: absolute;
    width: 60%;
    left: 2%;
    bottom: 8%;
  }
  ${SIZES.mobile} {
    background: url(${config.assets.entrance.portrait});
    background-size: 100% 100%;
    background-position: top;

    #mobile-show {
      display: block;
      max-width: 500px;
      margin: 0 auto;
    }
    #mobile-hide {
      display: none;
    }
  }
`

export default function EntrancePages({ children }) {
  return (
    <Page>
      <Switch>
        <Route exact path={routes.root} component={WelcomePage} />
        <Route path={routes.login} component={LoginPage} />
      </Switch>
    </Page>
  )
}
